export default __webpack_public_path__ + "static/media/gas.0460c6bb.svg";